import { render, staticRenderFns } from "./PlaylistItem.vue?vue&type=template&id=16a09672&"
import script from "./PlaylistItem.vue?vue&type=script&lang=js&"
export * from "./PlaylistItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports